export const en = {
    'banner-connot-update-archived': 'Archived ads cannot be edited',
    'banner-creative-not-supported': 'Select a video clip that matches the technical requirements.',
    'banner-creative-required': 'Upload creative',
    'banner-image-required': 'Upload image',
    'banner-image-size-modification': 'Can only be replaced by an image of the same size',
    'banner-image-size-modification-adaptive': 'It can only be replaced with an image of the same size (adaptive)',
    'banner-image-size-modification-with-size': 'Can only be replaced by an image of the same size ({size})',
    'banner-invalid-sitelinkset-usage': 'If a sitelink is given, then the URL must also be given.',
    'banner-required-href': 'Specify the site URL',
    'banner-required-href-or-vcard': 'Enter the URL, create a Turbo page, or fill out a virtual business card',
    'banner-required-href-turbo-vcard-organization':
        'Enter the link to your site, create a Turbo page, fill out your vCard or link a company from the Yandex Business Directory',
    'banners-text-language-inconsistent-with-geo-belarusian':
        'The ad text is written in Belarusian and does not match the selected display region. Ad may only be served in Belarus.',
    'banners-text-language-inconsistent-with-geo-default':
        'Language of ad text does not match the selected display region.',
    'banners-text-language-inconsistent-with-geo-kazakh':
        'The ad text is written in Kazakh and does not match the selected display region. Ad may only be served in Kazakhstan.',
    'banners-text-language-inconsistent-with-geo-turkish':
        'The ad text is written in Turkish and does not match the selected display region. Ad may only be served in Turkey.',
    'banners-text-language-inconsistent-with-geo-ukraine':
        'The ad text is written in Ukrainian and does not match the selected display region. Ad may only be served in Ukraine.',
    'banners-text-language-inconsistent-with-geo-uzbek':
        'The ad text is written in Uzbek and does not match the display region. Ads can only be served in Uzbekistan.',
    'body-invalid-template-query': 'Template may only be used once.',
    'body-max-length': {
        one: 'The ad text exceeded the max length of {count} character',
        some: 'The ad text exceeded the max length of {count} characters',
        many: 'The ad text exceeded the max length of {count} characters',
        none: 'The ad text exceeded the max length of {count} characters'
    },
    'body-max-narrow-length':
        'Ad text may contain no more than {maxLength} periods, commas, colons, semicolons, quotation marks, and exclamation points',
    'body-max-world-length': 'Words in ad text may not exceed {maxLength} characters',
    'body-restricted-chars-in-field':
        'Ad messages may only contain letters from Latin, Turkish, Russian, Ukrainian, Belarusian, and Kazakh languages as well as numbers and punctuation marks.',
    'body-should-not-be-blank': 'Enter ad text',
    'callout-text-cannot-be-empty': 'Enter callout text',
    'callout-text-length-exceeded': 'Callout length exceeded',
    'callout-text-not-allowed-symbols':
        'Callout text may only contain letters from Latin, Turkish, Russian, Ukrainian, Belarusian, and Kazakh languages as well as punctuation marks other than "!" and "?".',
    'callout-unknown-error': 'An error occurred while running the query. Try again later.',
    'callout-used': 'Cannot delete callout that is in use by another ad',
    'callouts-max-size': 'No more than {maxSize} callouts may be assigned to one ad',
    'cannot-be-empty': 'Field cannot be empty',
    'choose-correct-template': 'Select the correct template',
    'collection-is-inaccessible': 'Collection is not available',
    'description-cannot-be-less-than-max': 'Minimum number of characters: {minLength}',
    'description-cannot-be-more-than-max': 'Maximum character length - {maxLength}',
    'display-href-invalid-template-query': 'Template may only be used once',
    'displayhref-max-length': 'Display link exceeds the allowed {maxLength} character length',
    'domain-invalid-value': 'Incorrect domain format',
    'duplicate-error': 'Only one image for each size can be selected for batch changes',
    'equal-pixels': 'Tracking tags for the following providers are specified more than once: {providerNames}.',
    'gif-file-error-text': 'Cannot process GIF files',
    'href-file-format-invalid': "Couldn't upload image from link. Server returned 400 error.",
    'href-file-invalid': 'Incorrect file format',
    'href-image-file-size-invalid': 'File size is too big',
    'href-invalid': 'Incorrect link format',
    'href-invalid-or-no-scheme': 'Invalid link format or unspecified scheme',
    'href-invalid-or-not-https-scheme': 'Invalid link format or non-https scheme',
    'href-invalid-value': 'Incorrect link format',
    'href-max-length': 'URL exceeds the allowed {maxLength} character length',
    'href-null': 'Link cannot be empty',
    'href-or-turbo-required': 'Enter the URL or create a Turbo page',
    'href-should-not-be-blank': 'Enter a URL',
    'image-gallery-empty-images': 'No images found in gallery',
    'image-invalid-file-size-param': 'File size is larger than allowed ({maxSize} KB)',
    'image-invalid-format': 'Invalid file format. Use GIF, JPEG, and PNG image formats.',
    'image-invalid-formats': 'Invalid file type. Use image formats: {formats}',
    'image-invalid-sizes': 'Invalid image size',
    'image-invalid-sizes-mc-banner': 'Use a creative sized 240x400 px',
    'image-not-equal': 'Image size does not meet requirements',
    'image-not-equal-height': 'Image height does not meet requirements: {height} pixels',
    'image-not-equal-width': 'Image width does not meet requirements: {width} pixels',
    'image-not-equal-width-height': 'Image size does not meet requirements: {width} × {height} pixels',
    'image-too-big': 'Image size exceeds the limits',
    'image-too-big-height': 'Image height exceeds the limit: {height} pixels',
    'image-too-big-width': 'Image width exceeds the limit: {width} pixels',
    'image-too-big-width-height': 'Image size exceeds the limits: {width} × {height} pixels',
    'image-too-small': 'Image size is below acceptable limits',
    'image-too-small-height': 'Image height is below acceptable limits: {height} pixels',
    'image-too-small-width': 'Image width is below acceptable limits: {width} pixels',
    'image-too-small-width-height': 'Image size is below acceptable limits: {width} × {height} pixels',
    'incorrect-measures': 'Invalid format',
    'incorrect-pixel-url': 'The code you entered does not match the format of allowed tags.',
    'incorrect-ya-auditory-pixel-url':
        "The code you've entered does not match the Yandex.Audience pixel code format. Please use the Yandex.Audience service to get a pixel code",
    'invalid-choice-value': 'Invalid value selected',
    'invalid-link': 'Invalid link',
    'invalid-promotion-collection-link': 'The value entered is not a link to Yandex.Collections',
    'invalid-promotion-video-link': 'The value entered is not a video link',
    'must-be-empty': 'This field must be empty',
    'no-right-to-pixel':
        'Incorrect tag format. You can use the {counters} tag to collect statistics. The link must contain the %random% macro.',
    'not-enough-cards-in-collection': 'A collection must contain at least {count} cards',
    or: 'or',
    'organization-not-found': 'The selected company is not found in the Yandex Business Directory',
    'template-not-allowed': 'The selected template is unavailable',
    'title-invalid-template-query': 'Template may only be used once',
    'title-max-length': 'Title length exceeded by {maxLength} symbols',
    'title-max-length-word': 'Words in title may not exceed the allowed {maxLength} character length',
    'title-max-narrow-length':
        'Titles may contain no more than {maxLength} periods, commas, colons, semicolons, quotation marks, and exclamation points.',
    'title-restricted-chars-in-field':
        'Title may only contain letters from Latin, Turkish, Russian, Ukrainian, Belarusian, and Kazakh languages as well as numbers and punctuation marks.',
    'title-should-not-be-blank': 'Enter a title',
    'tns-id-cannot-be-empty': "Field can't be empty",
    'tns-id-length': {
        one: 'The maximum TNS ID length of {maxLength} character has been exceeded',
        some: 'The maximum TNS ID length of {maxLength} characters has been exceeded',
        many: 'The maximum TNS ID length of {maxLength} characters has been exceeded',
        none: 'The maximum TNS ID length of {maxLength} characters has been exceeded'
    },
    'tns-id-restricted-characters': 'Field contains forbidden characters',
    'turbo-gallery-href-max-length': 'Exceeded the maximum length of a link to rich answers by {maxLength} characters',
    'turbo-href-params-length': 'Tracking parameters exceed the allowed {maxLength} character length',
    'turbo-required': 'Select the Turbo page',
    'unknown-error-header': 'An unexpected error occurred',
    'unknown-error-text': 'An unexpected error occurred. Try again later.',
    'video-is-inaccessible': 'Video is not available'
};
